import React from "react";

interface ProfileExistsModalProps {
  isOpen: boolean;
  email: string;
  onContinue: () => void;
  onStartFresh: () => void;
  onClose: () => void;
}

export const ProfileExistsModal: React.FC<ProfileExistsModalProps> = ({
  isOpen,
  email,
  onContinue,
  onStartFresh,
  onClose,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
        <div className="text-center">
          <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-blue-100 mb-4">
            <svg
              className="h-6 w-6 text-blue-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </div>

          <h3 className="text-lg font-medium text-gray-900 mb-2">
            Profile Found
          </h3>

          <p className="text-sm text-gray-500 mb-6">
            We found an existing profile for <strong>{email}</strong>. Would you
            like to continue where you left off, or start fresh?
          </p>

          <div className="space-y-3 mb-6">
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 text-left">
              <h4 className="font-medium text-blue-800 text-sm mb-1">
                Continue Where You Left Off
              </h4>
              <p className="text-xs text-blue-700">
                Load your existing profile data and continue editing from where
                you stopped.
              </p>
            </div>

            <div className="bg-green-50 border border-green-200 rounded-lg p-3 text-left">
              <h4 className="font-medium text-green-800 text-sm mb-1">
                Start Fresh
              </h4>
              <p className="text-xs text-green-700">
                Begin with a clean slate. Your existing profile will be updated
                with new information.
              </p>
            </div>
          </div>

          <div className="flex space-x-3">
            <button
              onClick={onClose}
              className="flex-1 px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Cancel
            </button>
            <button
              onClick={onStartFresh}
              className="flex-1 px-4 py-2 border border-transparent rounded-md text-sm font-medium text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
            >
              Start Fresh
            </button>
            <button
              onClick={onContinue}
              className="flex-1 px-4 py-2 border border-transparent rounded-md text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Continue
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
